<i18n lang='yml' src='../i18n/ContainerMembersList.yml'></i18n>
<template>
  <div>
    <h5 class="margin-top heading-page">{{$t('list')}}</h5>

    <p class="border-bottom"> {{$t('list_info', { type: containerData.container_type[`name_en`]})}}</p>
    <ul class="nav nav-tabs">
      <li>
        <a :href="member_path">
          {{`${$t('member_list_types.members')} (${member_count})`}}
        </a>
      </li>
      <li>
        <a :href="pending_path">
          {{`${$t('member_list_types.pending')} (${pending_count})`}}
        </a>
      </li>
      <li>
        <a :href="invited_path">
          {{`${$t('member_list_types.invited')} (${invited_count})`}}
        </a>
      </li>
    </ul>

    <filter-bar :filter_params="filter_params" :filter_path="filter_path"/>


    <div v-if="containerData.container_type.options_store.show_progress_trackers" class="btn-toolbar update-member-progress-bar">
      <div class="col-sm-12 col-md-6 col-lg-4">
        <select id="progress" name="progress" class="form-control" v-model="container_membership.progress">
          <option value="" disabled selected>{{$t('progress_placeholder')}}</option>
          <option :key="item.id" v-for='item in statusData' :value="item.name">
            {{$t(`${item.name}`)}}
          </option>
        </select>
      </div>
      <div class="col-sm-12 col-md-6 col-lg-4">
        <multi-select 
          v-model="container_membership.roles"
          :options="getRoles(roleData)"
          mode="tags"
          :close-on-select="false"
          :hideSelected="false"
          v-bind="field" 
          :searchable="true"
          :create-option="false"
          :canClear="true"
          track-by="label"
          label="label"
          key="value"
          :placeholder="($t('roles_placeholder'))"
        />
      </div>
      <button :disabled="container_membership.roles.length == 0 || container_membership.progress == ''" class="btn btn-primary" :aria-label="$t('update')" @click.prevent="updateMemberProgress()">
        {{ $t('update') }}
      </button>
    </div>

    <div class="media-list">
      <div class="media" v-for="membership in membershipData" :key="membership.id">
      <div v-html="membership.user_avatar"/>
        <div class="media-body margin-left">
          <div class="action-bar">
            <h5 class="container-item-name"> {{nameForCurrentNetwork(membership.user.identity_cache.display_names)}}</h5>
            <div class="btn-group btn-group-sm ml-auto">
              <a class="btn btn-sm btn-outline-primary" :href="`${base_path}/${membership.id}`">
                <font-awesome-icon :icon="['fas', 'user']" />
                {{$t('edit_button')}}
              </a>
            </div>
          </div>
          <ul class="list-unstyled list-inline list-annotation">
            <li>
              <font-awesome-icon :icon="['fas', 'angle-double-right']" />
              <span>{{`ID ${membership.user.id}`}}</span>
            </li>
            <li>
              <font-awesome-icon :icon="['fas', 'user']" />
              {{locale == 'en' ? membership.network_role.name_en : membership.network_role.name_fr}}
            </li>
            <li>
              <font-awesome-icon :icon="['far', 'clock']" />
              {{ formatDate(membership.created_at) }}
            </li>
            <li v-if="containerData.container_type.options_store.show_progress_trackers && membership.progress_tracker">
              <font-awesome-icon :icon="['far', 'dot-circle']" />
              {{$t(membership.progress_tracker.item_status)}}
            </li>
          </ul>
        </div>
      </div>
      <pagination :expansion_threshold="expansion_threshold" :page_count="parseInt(page_count)"/>
    </div>
  </div>
</template>
<script>
  import Main from '../../../filter_bar/components/Main.vue';
  import pagination from '../../../shared/pagination/Pagination.vue';
  import { sendAjaxRequest } from '../../../shared/typescripts/ajax.ts';
  import {formatDate} from '../../../shared/typescripts/dates.ts'

  export default {
    props: [
      'locale',
      'memberships',
      'container',
      'member_path',
      'pending_path',
      'invited_path',
      'filter_params',
      'filter_path',
      'invited_count',
      'pending_count',
      'member_count',
      'network',
      'roles',
      'base_path',
      'progress_statuses',
      'page_count',
      'expansion_threshold'
    ],

    components: {
      'filter-bar': Main,
      pagination
    },

    data() {
      return {
        membershipData: [],
        containerData: {},
        error: false,
        roleData: [],
        statusData: null,
        container_membership: {
          roles: [],
          progress: ''
        },
        userList: []
      }
    },

    beforeMount() {
      try{
        this.containerData = JSON.parse(this.container);
      }
      catch(e){
        this.error = true;
      }
    },

    mounted() {
      this.$i18n.locale = this.locale;

      try{
        this.membershipData = JSON.parse(this.memberships);
        this.roleData = JSON.parse(this.roles);
        this.statusData = JSON.parse(this.progress_statuses)
      }
      catch(e){
        this.error = true;
      }
    },
    

    methods: {
      getRoles(data,) {
        let newArray = [];
        if (data.length > 0) {
          data.map((item) => {
          let _vm = this
          newArray.push({value: item.id, label: item[`name_${_vm.locale}`]})
        })
        return newArray
        }
      
      },
      nameForCurrentNetwork(display_names){
        var keys = Object.keys( display_names );

        for (var i = 0; i < keys.length; i++){
         return display_names[ keys[ i ] ];
        }
      },

      setUsers(users) {
        this.usersList = users;
      }, 

      formatDate(dateString) {
        return formatDate(dateString)
      },

      updateMemberProgress(){
        if (confirm(this.$i18n.t('progress_update_warning', {type: this.createWarningString()}))) {
          return sendAjaxRequest('POST', `${this.base_path}/mass_update_progress`, 'json', {container_membership: this.container_membership}, this.ajaxSuccess)
        }
      },

      ajaxSuccess(data) {
        this.loading = false;
        window.location.reload();
        return data;
      },

      createWarningString(){
        let role_names = []
        role_names.push(this.container_membership.roles.map((id) => this.roleData.find((el) => el.id == id).name_en));
        return role_names.join(', ')
      }
    },
  }
</script>
